import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Slider,
  Typography,
  Box,
  Divider
} from '@mui/material';

const TuningDialog = ({
  open,
  onClose,
  factorKey,
  parameters = {},
  onChange,
  industry,
  tier
}) => {
  const [localParams, setLocalParams] = useState(parameters);

  // Sync with parent parameters when they change
  useEffect(() => {
    setLocalParams(parameters);
  }, [parameters]);

  const handleValueChange = (paramName, value) => {
    setLocalParams(prev => ({
      ...prev,
      [paramName]: Number(value)
    }));
  };

  const handleSave = () => {
    onChange(localParams);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography variant="h6" component="div">
          Tuning Parameters for: {factorKey}
          <Typography variant="subtitle2" color="text.secondary">
            {industry} • {tier}
          </Typography>
        </Typography>
      </DialogTitle>
      
      <DialogContent dividers>
        <Box sx={{ p: 2 }}>
          {Object.entries(localParams).map(([paramName, value]) => (
            <Box key={paramName} sx={{ mb: 3 }}>
              <Typography gutterBottom>{paramName}</Typography>
              <Slider
                value={value}
                onChange={(_, val) => handleValueChange(paramName, val)}
                min={0}
                max={100}
                step={1}
                valueLabelDisplay="auto"
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                size="small"
                value={value}
                onChange={(e) => handleValueChange(paramName, e.target.value)}
                type="number"
                inputProps={{ 
                  min: 0,
                  max: 100,
                  step: 1
                }}
              />
            </Box>
          ))}
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={handleSave} 
          variant="contained" 
          color="primary"
        >
          Apply Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(TuningDialog);